// extracted by mini-css-extract-plugin
export default {"dottedBorderLeft":"Z35249KJgMpoE1f5td0j"};